export enum RazorpayControlAction {
  Checkout = 'checkout',
}

const getRazorpayActionOptions = () => [
  {
    const: RazorpayControlAction.Checkout,
    title: 'Checkout',
    icon: 'SvgAuthByUnifyapps',
    groupId: 1,
  },
];

export const getControlRazorpaySchema = () => {
  const actionOptions = getRazorpayActionOptions();
  return {
    type: 'object',
    properties: {
      operation: {
        type: 'string',
        title: 'Operation',
        default: RazorpayControlAction.Checkout,
        oneOf: actionOptions,
      },
    },
    allOf: [
      {
        if: {
          properties: {
            operation: { const: RazorpayControlAction.Checkout },
          },
        },
        then: {
          type: 'object',
          properties: {
            order_id: {
              type: 'string',
              title: 'Order ID',
            },
            amount: {
              type: 'number',
              title: 'Amount',
            },
            currency: {
              type: 'string',
              title: 'Currency',
              default: 'INR',
              oneOf: [
                { const: 'INR', title: 'INR' },
                { const: 'USD', title: 'USD' },
              ],
            },
          },
          required: ['order_id', 'amount', 'currency'],
        },
      },
    ],
  };
};

export const getControlRazorpayUISchema = () => {
  const actionOptions = getRazorpayActionOptions();

  return {
    operation: {
      'ui:title': 'Operation',
      'ui:widget': 'GroupedSelectWidget',
      'ui:options': {
        'ua:enumIcons': actionOptions.map((option) => option.icon),
        'ua:enumGroup': actionOptions.map((option) => option.groupId),
      },
    },
    order_id: {
      'ui:title': 'Order ID',
      'ui:placeholder': 'From Create Order API. Required for payment capture.',
    },
    amount: {
      'ui:title': 'Amount',
      'ui:placeholder': 'Enter amount in smallest unit (e.g., paise)',
    },
    currency: {
      'ui:title': 'Currency',
      'ui:widget': 'SelectWidget',
    },
  };
};
